AuthRoute = require 'mixins/authenticated-route'

App.BannersBannerEditStoryFrameRoute = Em.Route.extend AuthRoute,
  controllerName: 'story-frame.edit'

  setupController: (controller, model)->
    @_super(arguments...)
    banner = @modelFor('banners').find (banner) => banner.get('story_frames').some (frame) => frame.id is model.id
    controller.set('banner', banner)


  renderTemplate: (controller, model) ->
    @render 'banners.banner.edit.story-frame', controller: controller
